<template>
  <div class="videro-player">
    <div @click="play" v-if="!onPlayed && showPlayButton" class="videro-player__button-wrapper">
      <i class="el-icon-video-play" />
    </div>
    <video
      :video-src="videoSrc"
      ref="videoPlayer"
      :poster="poster"
      controls
      width="100%"
      @play="handlePlay"
      @pause="handlePause"
      :autoplay="autoplay"
      :muted="muted"
      :src="src"
    >
      Your browser does not support the video tag.
    </video>
  </div>
</template>

<script>
export default {
  name: 'vVideoPlayer',
  props: {
    src: {
      type: String,
    },
    poster: {
      type: String,
    },
    // 默认播放
    autoplay: {
      type: Boolean,
      default: false,
    },
    // 是否静音
    muted: {
      type: Boolean,
      default: false,
    },
    videoSrc: {
      type: String,
      default: null,
    },
    showPlayButton: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      onPlayed: this.autoplay, // 处于播放状态
    }
  },
  methods: {
    handlePlay() {
      this.onPlayed = true
    },
    handlePause() {
      this.onPlayed = false
    },

    play() {
      this.onPlayed = true
      const dom = this.$refs.videoPlayer
      if (dom?.play) dom.play()
    },

    // 暂停视频播放
    pause() {
      this.onPlayed = false
      const dom = this.$refs.videoPlayer
      if (dom.pause) dom.pause()
    },
  },
}
</script>

<style lang="scss" scoped>
.videro-player {
  width: 100%;
  min-height: 200px;
  position: relative;
  background-color: #000;
  &__button-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #00000035;
    i {
      cursor: pointer;
      font-size: 48px;
      color: #fff;
      &:hover {
        color: rgba(255, 255, 255, 0.587);
      }
    }
  }

  // 隐藏谷歌浏览器下的下载按钮
  video {
    &::-internal-media-controls-download-button {
      display: none;
    }
    &::-webkit-media-controls-enclosure {
      width: calc(100% + 45px);
      overflow: hidden;
    }
    &::-webkit-media-controls {
      overflow: hidden !important;
    }
    &::-webkit-media-controls-enclosure {
      margin-left: auto;
    }
  }
}
</style>
